import { useEffect, useMemo, useState } from "react";

const IDE_URL_HTTPS = "https://ide.co-agent.ru/?folder=/workspace";
const IDE_PORT_LEGACY = 3102;

export function Ide() {
  const ideUrl = useMemo(() => {
    const host = window.location.hostname || "localhost";
    if (host.endsWith("co-agent.ru")) return IDE_URL_HTTPS;
    const proto = window.location.protocol === "https:" ? "https:" : "http:";
    return `${proto}//${host}:${IDE_PORT_LEGACY}/?folder=/workspace`;
  }, []);

  const [hint, setHint] = useState<string | null>(null);

  useEffect(() => {
    if (hint) {
      const t = setTimeout(() => setHint(null), 1800);
      return () => clearTimeout(t);
    }
  }, [hint]);

  const copy = async (text: string, label: string) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setHint(`${label} скопировано`);
    } catch {
      setHint("Не удалось скопировать — выдели руками");
    }
  };

  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-wrap items-center gap-2 border-b border-panel-border bg-panel-card px-4 py-2 text-xs">
        <span className="font-semibold text-panel-fg">IDE (code-server)</span>
        <span className="text-panel-muted">
          первый вход — пароль из <code>.env</code> (<code>IDE_PASSWORD</code>)
        </span>
        <div className="flex-1" />
        <button
          className="btn text-xs"
          onClick={() =>
            copy(
              "claude",
              "Команда 'claude'",
            )
          }
          title="Скопировать 'claude' чтобы вставить в терминал code-server"
        >
          Копировать «claude»
        </button>
        <a
          className="btn text-xs"
          href={ideUrl}
          target="_blank"
          rel="noreferrer"
        >
          Открыть в новой вкладке ↗
        </a>
        {hint && <span className="text-emerald-400">{hint}</span>}
      </div>
      <iframe
        title="code-server"
        src={ideUrl}
        className="flex-1 w-full border-0 bg-black"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
